import { render } from "./Empty.vue?vue&type=template&id=df6a4fe8"
const script = {}

import exportComponent from "/root/workspace/KpiManage-vue_PVju/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__